import { getAuthToken, setAuthToken } from './store';

const baseURL = 'https://api.shortsdev.com';

type QueryValue = string | number | boolean | (string | number | boolean)[];
type FetchConfig = Omit<RequestInit, 'body'> & {
  url: string;
  params?: Record<string, QueryValue | undefined>;
  data?: any;
  responseType?: string;
};

export const client = async <T>(
  config: FetchConfig,
  options?: Omit<RequestInit, 'body'> & { noRefresh?: boolean },
): Promise<T> => {
  const { url, params = {}, method, data, headers } = config;
  const { noRefresh = false, ...requestOptions } = options ?? {};
  const { accessToken, refreshToken } = getAuthToken() ?? {};

  let body = {};
  // @ts-ignore
  let contentType = headers?.['Content-Type'] || 'application/json';
  if (data) {
    if (contentType === 'application/x-www-form-urlencoded') {
      body = { body: data };
    } else {
      body = { body: JSON.stringify(data) };
    }
  }

  const response = await fetch(`${baseURL}${url}${getQueryString(params)}`, {
    method,
    ...body,
    ...requestOptions,
    headers: {
      'x-api-version': '2024-10-16',
      Authorization: `Bearer ${accessToken}`,
      ...headers,
      ...requestOptions?.headers,
      'Content-Type': contentType,
    },
  });

  if (response.ok) {
    const res = await response.json();
    // if (res.data.success === false) {
      // throw res;
    // } else {
      return res;
    // }
  // 401 또는 500 에러 발생
  } else if (refreshToken && !noRefresh) {
    let refreshed = false;
    try {
      const refreshedToken = await tokenRefresh();
      // if (refreshedToken.status === 'success') {
        setAuthToken(refreshedToken.data);
        refreshed = true;
      // }
    } catch (err) {
      // failed to refresh access token
      // do nothing here
      console.error('refresh error', err);
    }
    if (refreshed) {
      // retry api call using new access token
      return await client(config, { ...options, noRefresh: true });
    }
  }

  throw await response.json();
};

function getQueryString(
  params: Record<string, QueryValue | undefined> | undefined,
) {
  if (!params) return '';

  const query = Object.entries(params).filter(
    ([, value]) => typeof value !== 'undefined',
  ) as [string, QueryValue][];

  if (!query.length) return '';

  return `?${query
    .map(([key, value]) => {
      if (typeof value === 'object') {
        return value.map((w) => `${key}=${encodeURIComponent(w)}`).join('&');
      }
      return `${key}=${encodeURIComponent(value)}`;
    })
    .join('&')}`;
}

async function tokenRefresh(): Promise<any> {
  const token = getAuthToken();
  return await client(
    {
      url: `/auth/token_refresh`,
      method: 'post',
      data: { token: token?.refreshToken },
    },
    { noRefresh: true },
  );
}
